export default "__VITE_ASSET__D$HvyWHM__"